
import React from "react";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <main className="about-us-page">
      <section className="about-us-hero">
        <p className="about-us-label">GET TO KNOW US</p>
        <h1>About Nayra Fashions</h1>
        <p className="about-us-tagline">Where Comfort Meets You</p>
      </section>

      <section className="about-us-content">
        <h2>Our Story</h2>
        <p>
         About Us – NAYRA FASHIONS
Where Comfort Meets You
Founded in 2025 by Vasanthi, NAYRA FASHIONS was born out of a passion for fashion and a commitment to providing women with premium-quality clothing that combines style, comfort, and confidence.
At NAYRA FASHIONS, we believe fashion is not just about how you look, but also about how you feel. Every woman has her own preferences, and finding the right outfit means more than choosing a beautiful design. Fabric quality, comfort, fitting, durability, and finishing are equally important.
We understand the everyday challenges women face when choosing and wearing clothes. Our goal is to make fashion more comfortable, practical, and affordable without compromising on quality.
Our Collections
NAYRA FASHIONS offers a wide range of women's clothing, including co-ord sets, two/three-piece kurti sets, frocks, and sarees from carefully selected brands, along with our own clothing brand, NAYRA.
Our collections bring together style, comfort, and quality to suit different tastes, occasions, and lifestyles. From everyday wear to elegant ethnic collections, we aim to help every woman find outfits that match her personality and make her feel confident.
Our Commitment
At NAYRA FASHIONS, quality is never a compromise. Our founder, Vasanthi, is committed to providing premium-quality products and attentive customer service.
We listen to our customers and value their preferences, tastes, and feedback. We also keep learning about changing fashion trends and evolving expectations for comfort and fitting. This helps us improve our collections and offer clothing that meets women's needs.
For us, customers are more than just buyers- they are friends who are part of our growing fashion family. We strive to make every shopping experience personal, satisfying, and enjoyable.
Our Journey into Wholesale
In 2026, NAYRA FASHIONS expanded into the wholesale segment with a vision to make quality clothing accessible to more customers and fashion businesses.
Our focus goes beyond stylish designs. We aim to provide well-tailored garments that complement different body shapes and offer a comfortable fit. Through our commitment to customisation, precise fitting, and neat finishing, we strive to help our wholesale partners meet their customers' expectations.
This expansion marks an important milestone in our journey, allowing us to reach more people while staying true to our values of quality, comfort, and customer satisfaction.
Growing Together
Since our beginning in 2025, we have been grateful for the trust and support of our customers. Every suggestion, preference, and experience shared by them inspires us to learn, improve, and bring better fashion choices to women.
As we continue to grow, our promise remains the same: to understand women better, deliver quality they can trust, and make fashion comfortable, accessible, and enjoyable.
NAYRA FASHIONS — Where Comfort Meets You.
        </p>

        {/* Add your complete About Us content here. */}
      </section>
    </main>
  );
};

export default AboutUs;
